import { render, staticRenderFns } from "./NewsMobile.vue?vue&type=template&id=44a45687&scoped=true&"
import script from "./NewsMobile.vue?vue&type=script&lang=js&"
export * from "./NewsMobile.vue?vue&type=script&lang=js&"
import style0 from "./NewsMobile.vue?vue&type=style&index=0&id=44a45687&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44a45687",
  null
  
)

export default component.exports